import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation("common", { keyPrefix: "footer" });
  return (
    <Box
      component="footer"
      sx={{
        minHeight: 100,
        py: { xs: 3, md: 0 },
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: "center",
        justifyContent: "center",
        textAlign: { xs: "center", md: "left" },
        gap: { xs: 2, md: 8 },
        fontSize: 10,
        color: "white",
        textTransform: "uppercase",
        backgroundColor: "#263238",

        "& ul": {
          display: "flex",
          gap: 4,
          listStyle: "none",
          padding: 0,
          margin: 0,
        },

        "& a": {
          color: "inherit",
          textDecoration: "none",

          "&:hover": {
            textDecoration: "underline",
          },
        },
      }}
    >
      <Box
        component="img"
        src="/assets/v2/AE-Connect.png"
        alt="AE Connect"
        sx={{ width: { xs: 132, md: 196 }, height: "auto" }}
      />

      <ul>
        <li>
          <a href="/privacy-policy" target="_blank">
            {t("privacyPolicy")}
          </a>
        </li>
      </ul>

      <Box component="p" sx={{ fontSize: 8, m: 0, maxWidth: 260 }}>
        {t("copyrightText", { year: new Date().getFullYear() })}
      </Box>
    </Box>
  );
}
